import { useTranslation } from 'react-i18next';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { ResponsiveDialog } from '@/components/common/ResponsiveDialog';

interface ServiceBookFillDialogProps {
  open: boolean;
  loading?: boolean;
  onYes: () => void;
  onNo: () => void;
  onCancel: () => void;
}

export function ServiceBookFillDialog({
  open,
  loading = false,
  onYes,
  onNo,
  onCancel,
}: ServiceBookFillDialogProps) {
  const { t } = useTranslation('workorders');
  const { t: tc } = useTranslation('common');

  return (
    <ResponsiveDialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      mobileTitle={t('serviceBook.fillPromptTitle')}
    >
      <DialogTitle>{t('serviceBook.fillPromptTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('serviceBook.fillPromptMessage')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          {tc('cancel')}
        </Button>
        <Button onClick={onNo} disabled={loading} data-testid="service-book-fill-no">
          {t('serviceBook.fillNo')}
        </Button>
        <Button
          onClick={onYes}
          variant="contained"
          disabled={loading}
          data-testid="service-book-fill-yes"
        >
          {t('serviceBook.fillYes')}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  );
}
